import moment from "moment";
import React, { useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import {
    Alarms,
    Analytics,
    BusinessAnalytics,
    CallLog,
    CallResponseTime,
    CallTimingsCard,
    Category,
    ChangePassword,
    CommonLayout,
    Contacts,
    DailyCoTable,
    DemoGraphic,
    Details,
    Expenditure,
    ForgotPassword,
    GitDashboardChart,
    GitDashboardTable,
    HKAnalytics,
    Home,
    HotelDashboard,
    HotelDashboardTickets,
    HotelStaffResponseTime,
    HotelWidgets,
    HubSpotTable,
    JiraDashboard,
    JiraTicketsTable,
    KioskPropertiesTable,
    LikeDislikeTable,
    LinkExpired,
    LogIn,
    MaintenanceAnalytics,
    NewCallDetailsTable,
    NotFound,
    OperationDetails,
    QueueInstances,
    ReportsTable,
    ReservationAnalytics,
    RestartHistoryTable,
    Reviews,
    ReviewsTable,
    RoomsAvailable,
    ScanDetailsTable,
    ServerInstances,
    SprintAnalytics,
    SupportDetailsTable,
    TeamManagement,
    TicketForm,
    TicketsByComponents,
    TicketsByPriorityTable,
    TotalTimeDuration,
    TransactionDuration,
    TransactionDurationTable,
    UpcomingHotelList,
    UserList,
    VendorList,
    VerifyOTP as VerifyLogInOTP,
    ConfirmPassword as VerifyPassword,
    WalkInLog,
    CallsAnswered,
    CallsAnsweredDetails,
    MissedCalls,
    MissedCallDetails,
} from "./components";
import BuildUploader from "./components/BuildUploader/BuildUploader";
import MapContainer from "./components/Map/MapContainer";
import SupportAnalytics from "./components/SupportAnalytics/SupportAnalytics";
import Nexus from "./components/Nexus/Index";
import NexusHotel from "./components/Nexus/NexusHotel";
import NexusAgentStatus from "./components/Nexus/NexusAgentStatus";
import ShiftNotes from "./components/ShiftNotes/ShiftNotes";
import HotelShiftNotes from "./components/ShiftNotes/HotelShiftNotes";
import Receipt from "./components/ReceiptAnalytics/Receipt";
import HotelReceipts from "./components/ReceiptAnalytics/HotelReceipts";
import ReceiptDetails from "./components/ReceiptAnalytics/ReceiptDetails";
import { initialDateRange } from "./services/util";
import { QualityMatricsDetails } from "./components/Details/QualityMatricsDetails";
import CallWaitingDetails from "./components/Nexus/CallWaiting/CallWaitingDetails";
import MissedCallRate from "./components/MissedCallRate/MissedCallRate";
import CallLogDetails from "./components/CallLog/CallLogDetails";

const SettingContext = React.createContext();

export function CustomRoutes() {
    const [selectedDates, setSelectedDates] = useState(initialDateRange);
    const [selectedHotelType, setSelectedHotelType] = useState("all");
    const [selectedHotels, setSelectedHotels] = useState([]);
    const [singleSelectedHotels, setSingleSelectedHotels] = useState("");
    const [kioskSelection, setKioskSelection] = useState("1");
    const [loggedIn, setLoggedIn] = useState(
        Boolean(localStorage.getItem(`loggedIn`)),
    );
    const [rabbitClient, setRabbitClient] = useState(null);
    const [rabbitQueue, setRabbitQueue] = useState(null);
    const [selectedCheckinType, setSelectedCheckinType] = useState(0);
    const [selectedReceiptTab, setSelectedRecipetTab] = useState("mail");
    const [selectedNexusHotelId, setSelectedNexusHotelId] = useState([]);
    const [selectedNexusDates, setSelectedNexusDates] =
        useState(initialDateRange);
    const [callWaitingTab, setCallWaitingTab] = useState("call_waiting");

    const [homeActiveTab, updateHomeActiveTab] = useState("1");
    const context = {
        selectedDates,
        setSelectedDates,
        selectedHotels,
        setSelectedHotels,
        loggedIn,
        setLoggedIn,
        singleSelectedHotels,
        setSingleSelectedHotels,
        selectedHotelType,
        setSelectedHotelType,
        kioskSelection,
        setKioskSelection,
        rabbitClient,
        setRabbitClient,
        rabbitQueue,
        setRabbitQueue,
        selectedCheckinType,
        setSelectedCheckinType,
        selectedReceiptTab,
        setSelectedRecipetTab,
        selectedNexusHotelId,
        setSelectedNexusHotelId,
        selectedNexusDates,
        setSelectedNexusDates,
        homeActiveTab,
        updateHomeActiveTab,
        callWaitingTab,
        setCallWaitingTab,
    };

    return (
        <SettingContext.Provider value={context}>
            <Router>
                <Routes>
                    <Route
                        path="/"
                        element={
                            <CommonLayout>
                                <Home />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/nexus-dashboard"
                        element={
                            <CommonLayout>
                                <Nexus />
                            </CommonLayout>
                        }
                    />
                    <Route path="/details/:type" element={<Details />} />
                    <Route
                        path="/quality-metrics-details/:component"
                        element={<QualityMatricsDetails />}
                    />
                    <Route
                        path="/total-time-duration"
                        element={<TotalTimeDuration />}
                    />
                    <Route path="/calls/:hotel_id" element={<DailyCoTable />} />
                    <Route path="/login" element={<LogIn />} />
                    <Route
                        path="/analytics"
                        element={
                            <CommonLayout>
                                <Analytics />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/sprint-analytics"
                        element={
                            <CommonLayout>
                                <SprintAnalytics />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/support-analytics"
                        element={
                            <CommonLayout>
                                <SupportAnalytics />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/team-manangement"
                        element={
                            <CommonLayout>
                                <TeamManagement />
                            </CommonLayout>
                        }
                    />
                    <Route path="/verify-otp" element={<VerifyLogInOTP />} />
                    <Route
                        path="/change-password"
                        element={<ChangePassword />}
                    />
                    <Route
                        path="/forgot-password"
                        element={<ForgotPassword />}
                    />
                    <Route
                        path="/verify-password"
                        element={<VerifyPassword />}
                    />
                    <Route path="/link-expired" element={<LinkExpired />} />
                    <Route path="/map" element={<MapContainer />} />
                    <Route path="/category" element={<Category />} />
                    <Route
                        path="/demographic-analytics"
                        element={
                            <CommonLayout>
                                <DemoGraphic />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/kiosk-properties"
                        element={
                            <CommonLayout>
                                <KioskPropertiesTable />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/vendors"
                        element={
                            <CommonLayout>
                                <VendorList />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/ticket-form"
                        element={
                            <CommonLayout>
                                <TicketForm />
                            </CommonLayout>
                        }
                    />
                    {/* <Route
                        path="/upcoming-hotels"
                        element={<UpcomingHotelList />}
                    /> */}
                    <Route path="/reviews-table" element={<ReviewsTable />} />
                    <Route
                        path="/new-call-details"
                        element={<NewCallDetailsTable />}
                    />
                    <Route path="/call-log" element={<CallLog />} />
                    <Route path="/call-log/:hotel_id" element={<CallLogDetails />} />
                    <Route path="/walkIn-log" element={<WalkInLog />} />
                    <Route path="/call-time" element={<CallTimingsCard />} />
                    <Route path="/reviews-graph" element={<Reviews />} />
                    <Route
                        path="/transaction-duration-table"
                        element={<TransactionDurationTable />}
                    />
                    <Route path="/call-answered" element={<CallsAnswered />} />
                    <Route path="/call-missed" element={<MissedCalls />} />
                    <Route
                        path="/call-answered-details/:id"
                        element={<CallsAnsweredDetails />}
                    />
                    <Route
                        path="/call-missed-details/:id"
                        element={<MissedCallDetails />}
                    />
                    <Route
                        path="/operation-details"
                        element={<OperationDetails />}
                    />
                    <Route
                        path="/hotel-dashboard"
                        element={<HotelDashboard />}
                    />
                    <Route
                        path="/hotel-dashboard/tickets/:type"
                        element={<HotelDashboardTickets />}
                    />
                    <Route
                        path="/scan-details-table"
                        element={<ScanDetailsTable />}
                    />
                    <Route
                        path="/support-details-table"
                        element={<SupportDetailsTable />}
                    />
                    <Route
                        path="/hubSpot-details-table"
                        element={<HubSpotTable />}
                    />
                    <Route
                        path="/like-dislike-details"
                        element={<LikeDislikeTable />}
                    />
                    <Route
                        path="/transaction-duration-graph/:hotel_id"
                        element={<TransactionDuration />}
                    />
                    <Route path="/shift_notes" element={<ShiftNotes />} />
                    <Route
                        path="/shift_notes/:hotel_id"
                        element={<HotelShiftNotes />}
                    />
                    <Route path="/sent_receipt" element={<Receipt />} />
                    <Route
                        path="/sent_receipt/:hotel_id"
                        element={<HotelReceipts />}
                    />
                    <Route
                        path="/sent_receipt/:hotel_id/:receipt_is_for"
                        element={<ReceiptDetails />}
                    />
                    <Route
                        path="/jira-dashboard"
                        element={
                            <CommonLayout>
                                <JiraDashboard />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/jira-dashboard/tickets/:range"
                        element={<JiraTicketsTable />}
                    />
                    <Route
                        path="/jira-dashboard/priority-tickets/:priority"
                        element={<TicketsByPriorityTable />}
                    />
                    <Route
                        path="/tickets-chart"
                        element={
                            <CommonLayout>
                                <TicketsByComponents />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/git-dashboard"
                        element={
                            <CommonLayout>
                                <GitDashboardChart />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/git-dashboard/table"
                        element={<GitDashboardTable />}
                    />
                    <Route
                        path="/hotels"
                        element={
                            <CommonLayout>
                                <HotelWidgets />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/users"
                        element={
                            <CommonLayout>
                                <UserList />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/alarms"
                        element={
                            <CommonLayout>
                                <Alarms />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/rooms"
                        element={
                            <CommonLayout>
                                <RoomsAvailable />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/report-settings"
                        element={
                            <CommonLayout>
                                <ReportsTable />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/business-analytics"
                        element={
                            <CommonLayout>
                                <BusinessAnalytics />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/restart-history"
                        element={<RestartHistoryTable />}
                    />
                    <Route
                        path="/build-upload"
                        element={
                            <CommonLayout>
                                <BuildUploader />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/queue-instances"
                        element={
                            <CommonLayout>
                                <QueueInstances />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/server-instances"
                        element={
                            <CommonLayout>
                                <ServerInstances />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/Expenditure"
                        element={
                            <CommonLayout>
                                <Expenditure />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/contacts"
                        element={
                            <CommonLayout>
                                <Contacts />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/nexus-hotels"
                        element={
                            <CommonLayout>
                                <NexusHotel />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/nexus-agents-status"
                        element={
                            <CommonLayout>
                                <NexusAgentStatus />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/nexus-agents-status/call-wating-detail"
                        element={
                            <CommonLayout>
                                <CallWaitingDetails />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/average_reponse_time"
                        element={<CallResponseTime />}
                    />
                    <Route
                        path="/average_staff_reponse_time"
                        element={<HotelStaffResponseTime />}
                    />
                    <Route
                        path="/missed-call-rate"
                        element={<MissedCallRate />}
                    />
                    {/* <Route
                        path="/housekeeping-analytics"
                        element={
                            <CommonLayout>
                                <HKAnalytics />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/maintenance-analytics"
                        element={
                            <CommonLayout>
                                <MaintenanceAnalytics />
                            </CommonLayout>
                        }
                    />
                    <Route
                        path="/reservation-analytics"
                        element={
                            <CommonLayout>
                                <ReservationAnalytics />
                            </CommonLayout>
                        }
                    /> */}
                    <Route path="/404" element={<NotFound />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Router>
        </SettingContext.Provider>
    );
}

export { SettingContext };
